import { AccountBase, EntityType, Unionize, User, UserBase } from ".";

export const permissionLevels = ["manage", "read", "write", "view", "deny"] as const;
export type PermissionLevel = Unionize<typeof permissionLevels>;

export const permissionLevelWeights: Record<PermissionLevel, number> = {
  manage: 4,
  write: 3,
  read: 2,
  view: 1,
  deny: 0,
};

type UserPermission = {
  IdentityType: "user";
  Identity: Partial<User>;
};

type AccountPermission = {
  IdentityType: "account";
  Identity: AccountBase;
};

export type Permission = {
  ID?: string;
  Resource: {
    ID?: string;
    OwnedBy?: string | UserBase;
  };
  ResourceType?: EntityType;
  Level: PermissionLevel;
  Inherited?: PermissionLevel;
} & (UserPermission | AccountPermission);

/**
 * The parsedPermission array extends each permission with additional properties
 * to facilitate being edited..
 */
export type ExtendedPermission = Omit<Permission, "Level"> & {
  Level: PermissionLevel | "inherited";
  /**
   * Flag indicating if the permission has been added but not saved;
   */
  New?: boolean;
  /**
   * Flag indicating if the permission should be removed when permissions are saved
   */
  Remove?: boolean;
  /**
   * Flag indicating if the inherited permission override should be removed when permissions are saved
   */
  Revert?: boolean;
  /**
   * Flag indicating if the permission has been saved (used when saving permissions)
   */
  Submitted?: boolean;
  /**
   * Flag used to indate if the permission is read only (used when saving permissions)
   */
  ReadOnly?: boolean;
  /**
   * Indication if the permission is for unregistered users and those who are outside resource's account
   */
  External?: boolean;
  /**
   * Indication for external permissions if the initial permission level given is beyond collaborator
   */
  Downgraded?: boolean;
  /**
   * Flag indicating whether license is assigned to the user granted with the permission
   */
  License?: boolean | null;
} & (UserPermission | AccountPermission);
